import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Stack, Typography } from "@mui/material";

import { icon, text } from "@/theme/colors";

/** Left in-page nav group header — 請求書. Shared by the edit & detail 請求設定 screens. */
export const InvoiceNavHeader = () => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1.5, py: 1 }}>
    <Typography variant="body14Bold" color={text.primary}>
      請求書
    </Typography>
    <KeyboardArrowUpIcon sx={{ color: icon.default, fontSize: 20 }} />
  </Stack>
);
